// CustomFields.js
import React, { useState, useEffect, useRef, Fragment } from 'react';
import { Field, useFormikContext, ErrorMessage } from 'formik';

const CustomFields = ({fields, sampleId, setFieldValue, error, setError, sampleRequest,sampleRequestData, setBloodVolume, sampleFieldRef, groupTotal, setGroupTotal}) => {
  const { values } = useFormikContext();
  const { errors } = useFormikContext();
  const { touched } = useFormikContext();
  const [enabledFields, setEnabledFields] = useState({});
  const [groupVolumes, setGroupVolumes] = useState({});  
  const [units, setUnits] = useState({});  
  // const [totalTubes, setTotalTubes] = useState(0);

  const [temp, setTemp] = useState(0);
  const sizes = {};
  const groupCheck = ["blood-tubes", "urine-sample-type", "exhaled-breathe-sample-type", "saliva-sample-type", "buccal-swab-sample-type", "hair-follic-sample-type", "skin-tape-sample-type", "stool-sample-type"];
  const maxVolumeAllowed = fields[0]?.maximun_allowed || 0;
  const fingerNoteRef = useRef(null); 
  
  var run = 0;
  useEffect(() => { 

    // console.log("groupTotal", groupTotal);

    run +=1;
    if( run === 1 && Object.entries(groupTotal).length===0 && Object.entries(groupTotal).length === 0){
            
        if (!sampleRequestData || typeof sampleRequestData !== "object") {
          // console.error("sampleRequestData is not an object or is undefined:", sampleRequestData);
          return;
        }
    
      const groupIdMapping = {
        "1": "blood-tubes",
        "2": "urine-sample-type",
        "3": "exhaled-breathe-sample-type",
        "4": "saliva-sample-type",
        "5": "buccal-swab-sample-type",
        "6": "hair-follic-sample-type",
        "7": "skin-tape-sample-type",
        "8": "stool-sample-type",
      };
    
      const groupCheck = [
        "blood-tubes",
        "urine-sample-type",
        "exhaled-breathe-sample-type",
        "saliva-sample-type",
        "buccal-swab-sample-type",
        "hair-follic-sample-type",
        "skin-tape-sample-type",
        "stool-sample-type",
      ];
  
      Object.entries(sampleRequestData).forEach(([groupId, data]) => {
        if(groupId == sampleId){
        const descriptiveGroupId = groupIdMapping[groupId]; // Map numeric ID to descriptive ID
    
        if (groupCheck.includes(descriptiveGroupId)) {
              
          // Process the options within the data
          Object.entries(data.options).forEach(([name, value]) => {
          
            if ((name.includes("numberoftubes") || name.includes("teer") || name.includes("skintapestrip") )&& !name.includes("bloodfingerpricknumberoftubes")  && groupId ==  sampleId) {
              const unit = "ml"; // Adjust this if the unit is dynamic
              const numericValue = parseFloat(value) || 0;
              handleVolumeChange(descriptiveGroupId, name, unit, numericValue);
            }
          });
        }
      }
      });
    }

    if (!groupTotal || typeof groupTotal !== 'object') return;
    handleGroupTotal();

  }, [groupTotal]);  

  
  const handleSampleRequestUpdate = (name, value) => {
    sampleRequest((prev) => {
        const currentOptions = prev[sampleId]?.options || {};
        return {
            ...prev, [sampleId]: { ...prev[sampleId], options: { ...currentOptions, [name]: value } }
        };
    });
  };

  const handleCheckboxChange = (name, checked, groupId, dependentField) => {
 
    if(name == 'bloodfingerpricktype') {
      if (fingerNoteRef.current) {
          if (!checked) {
              fingerNoteRef.current.style.display = 'none';
          } else {
              fingerNoteRef.current.style.display = 'block';
          }
      }
    }

    if(dependentField) {      
      setEnabledFields((prev) => ({
            ...prev,
            [groupId]: { ...(prev[groupId] || {}), [dependentField]: !checked,
          }
      }));

      if (!checked) {
          setFieldValue(dependentField, ''); 
          updateGroupVolume(groupId, dependentField, 0);
          handleSampleRequestUpdate(dependentField, '');
      }
    }

    
    setFieldValue(name, checked);
    handleSampleRequestUpdate(name, checked);
  };

  var count =0 ;  
  const handleVolumeChange = (groupId, name, unit, value) => { 
      count+=1; 
  
      const numericValue = parseFloat(value) || 0;
      updateGroupVolume(groupId, name, unit, numericValue);
      setFieldValue(name, value);
      handleSampleRequestUpdate(name, value);
  };

  const updateGroupVolume = (groupId, name, unit, volume) => {   
 
    let parsedVolumeSize = 1;
    // detect number of tubes and extract tube size
    if (name.includes("numberoftubes")) {
        const sizeIndex = name.replace("numberoftubes", "size");
        let volumeSize = sizes[sizeIndex] ?? "";
        parsedVolumeSize =
            (volumeSize.includes("mL") || volumeSize.includes("ml"))
                ? parseFloat(volumeSize.replace(/\s*m[lL]\s*/g, ""), 10)
                : 1;

        // --- NEW: Maintain total tubes ---  // this is commented cause this total tubes is counted from state group total.
        // setTotalTubes(prev => {
        //     if (groupId === "blood-finger-prick"){
        //       return prev;
        //     };
        //     const previousTubeCount = groupVolumes[groupId]?.[name + "_tubeCount"] || 0;
        //     const newTotal = prev - previousTubeCount + (volume || 0);
        //     console.log("New total: ",newTotal);
        //     return newTotal;
        // });
    }

    setGroupVolumes((prev) => {
      // Local groupVolume for the specific groupId
      let groupVolume = prev[groupId] ? { ...prev[groupId] } : {};
    
      // Identify deleted fields by comparing keys
      // const deletedFields = Object.keys(groupVolume).filter(
      //   (key) => !(groupTotal[groupId] && groupTotal[groupId].hasOwnProperty(key))
      // );
       const deletedFields = Object.keys(groupVolume).filter(
      (key) =>
        // keep tubeCount keys only if original field still exists in groupTotal
        !(
          key.endsWith("_tubeCount")
            ? groupTotal[groupId] && groupTotal[groupId].hasOwnProperty(key.replace("_tubeCount", ""))
            : groupTotal[groupId] && groupTotal[groupId].hasOwnProperty(key)
        )
    );
    
      // Remove deleted fields from groupVolume
      deletedFields.forEach((field) => {
        delete groupVolume[field];
      });
      
      // save tube count separately
      if (name.includes("numberoftubes")) {
        if (volume !== null && volume !== undefined) {
          groupVolume[name + "_tubeCount"] = volume;  
        }
        else{
        groupVolume[name + "_tubeCount"]= 0;
        }
      }

      // Add or update the current field if applicable
      if (volume !== null && volume !== undefined) {
        groupVolume[name] = volume * parsedVolumeSize;
      } else {
        groupVolume[name] = 0;
      }
    
      // Calculate the total for the updated groupVolume
      // const totalVolume = Object.values(groupVolume).reduce(
      //   (sum, val) => sum + (parseFloat(val) || 0),
      //   0
      // );
      
      const totalVolume = Object.entries(groupVolume).reduce((sum, [k, v]) => {
        // skip tubeCount entries from volume sum
        if (k.endsWith("_tubeCount")) return sum;
        return sum + (parseFloat(v) || 0);
      }, 0);

      // Update the parent state
      setGroupTotal((prevTotal) => ({
          ...prevTotal,
          [groupId]: {
              ...prevTotal[groupId], 
              [name]: volume * parsedVolumeSize,
              [name + "_tubeCount"]: volume,
              maxAllowed: maxVolumeAllowed
          },
      }));
    
      // Update the local state
      // console.log({
      //   ...prev,
      //   [groupId]: {
      //     ...(totalVolume > 0 ? groupVolume : {}), 
      //   },
      // });
      
      return {
        ...prev,
        [groupId]: {
          ...(totalVolume > 0 ? groupVolume : {}), 
        },
      };
    });

    setUnits((prev) => ({ ...prev, [groupId]: unit }));
 
  };

  const handleDecimalNumber = (event) => {
      if (event.key === '.' || event.key ==="-"  || event.key ==="+" ) {
          event.preventDefault();
      }
  };

  const renderFields = (type, label, name, placeholder, note, required, disabled, options, groupId, unit, dependentField) => {   
    const hasValue = values[name]; 
    if(type == 'Checkbox' && label =='Finger Prick' && hasValue == "1" ){
      if(name == 'bloodfingerpricktype') {
        
        if (fingerNoteRef.current) {
            if (!hasValue) {
                fingerNoteRef.current.style.display = 'none';
            } else {
                fingerNoteRef.current.style.display = 'block';
            }
        }
      }
    }
    const dropdownOptions = options ? JSON.parse(options) : []; 
    var isDisabled = enabledFields[groupId]?.[name] ?? disabled;    
 
  
    if(name.includes('numberoftubes')){ 
       isDisabled = values[name] === "" ? isDisabled : false ; 
    }
    

    switch (type) {
      case 'Label':        
        return (
          <span className="custom-form-label" dangerouslySetInnerHTML={{ __html: label }} />
        );
      
      case 'Input':
        return (
          <>
            {label && (
              <label htmlFor={label} className="form-label" dangerouslySetInnerHTML={{ __html: label }} />
            )}
            <Field
              type="text"
              name={name}
              placeholder={placeholder}
              className="form-control"
              disabled={isDisabled}
              onChange={(e) => handleVolumeChange(groupId, name, unit, e.target.value)}

            />
            {errors[name] && (
                <ErrorMessage name={name} component="div" className="text-danger" />
            )}
            <strong>{note}</strong>
          </>
      );

      case 'Number':
        const isBloodTube = groupId === "blood-tubes";
        const hasError = errors[name] && touched[name];
        return (
          <> 
          {/* {()=>{handleVolumeChange(groupId, name, unit, values[name], dependentField)}} */}
            <label>
            {label && (
              <span htmlFor={label} className="form-label" dangerouslySetInnerHTML={{ __html: label }} />
            )}
            {required && <span className="text-danger">*</span>}
            </label>
            <Field
              type="number"
              min="1"
              name={name}
              required={required}
              onKeyDown={handleDecimalNumber}
              placeholder={placeholder}
              className={`form-control ${hasError && isBloodTube ? 'input-error' : ''}`}
              disabled={isDisabled}
              onChange={(e) => handleVolumeChange(groupId, name, unit, e.target.value, dependentField)}
            />
            {errors[name] && !isBloodTube && (
                <ErrorMessage name={name} component="div" className="text-danger" />
            )}
            {hasError && isBloodTube && (
              <span
                className="error-icon tooltip-error"
                data-error={errors[name]}
              >
                !
              </span>
            )}

            <strong>{note}</strong>
          </>
        );  
        
      case 'Checkbox':
        return (
          <>              
            <Field
              type="checkbox"
              name={name}
              required={required}
              id={`${name}_${groupId || ''}`} 
              className="form-check-input" 
              onChange={(e) =>
                  handleCheckboxChange(name, e.target.checked, groupId, dependentField)
              }
            />&nbsp;&nbsp;
            {label && (
              <label htmlFor={`${name}_${groupId || ''}`} className="form-check-label" dangerouslySetInnerHTML={{ __html: label }} />
            )}
          </>
      );  
      
      case 'Dropdown': 
        return (
          <>
            {label && (
              <label htmlFor={label} className="form-label" dangerouslySetInnerHTML={{ __html: label }} />
            )}
            <Field 
            as="select" 
            name={name} 
            className="form-control"
            disabled={isDisabled}
            onChange={(e) => handleVolumeChange(groupId, name, unit, e.target.value)}
            >
                <option value="">Select # of  Drops</option>
                {dropdownOptions.map((value, index) => (
                    <option key={index} value={value}>{value}</option>
                ))}                                                                         
            </Field>
            {errors[name] && (
                <ErrorMessage name={name} component="div" className="text-danger" />
            )}  
            <strong>{note}</strong>
          </>
      );  
      
      default:
        return null;  

    }

  };
  

  const handleGroupTotal = () =>  {
    let tempTotal = {};
    // console.log("groupTotal", groupTotal);
    // console.log("groupVolumes", groupVolumes);
    Object.entries(groupTotal).forEach(([groupId, volumes]) => {
      
      if(groupCheck.includes(groupId)) {
        
        let totalVolume = 0;
        let totalTubes = 0;
        let maxAllowedVolume = 0;
        const unitDetails = units[groupId] || '';
        Object.entries(volumes).forEach(([field, value]) => { 
            // if(field !== 'maxAllowed') { 
            //   totalVolume += parseFloat(value) || 0;
            // } else if(field === 'maxAllowed'){
            //   maxAllowedVolume = value;
            // }
            if (field === "maxAllowed") {
              maxAllowedVolume = value;
              return;
            }

            //  Count tubeCount fields only
            if (field.endsWith("_tubeCount")) {
              totalTubes += parseFloat(value) || 0;
              return;
            }

            //  Sum volumes (exclude _tubeCount & maxAllowed)
            totalVolume += parseFloat(value) || 0;
        });

      
        setError((prev) => {
          const newErrors = { ...prev };

          if (totalVolume === 0) {
              newErrors[groupId] = `Please select amount per volunteer per day`;
          } 
          else if ( groupId === 'blood-tubes' &&  totalTubes > 10) {
            newErrors[groupId] = `Maximum total count of tubes allowed per donor is 10`;
          } 
          else if (totalVolume > maxAllowedVolume) {
              newErrors[groupId] = `Maximum amount per volunteer per day is ${maxAllowedVolume} ${unitDetails}`;
          } else {
              newErrors[groupId] = null;
          }
          return newErrors;
        });

        if(groupId === 'blood-tubes' && sampleId === 1) {
          setBloodVolume(totalVolume);
        }

        tempTotal[groupId] = totalVolume;
      }
    });    

    setTemp(tempTotal);
    setEnabledFields((prev) => {
      const updatedState = { ...prev };
      Object.keys(prev).forEach((groupId) => {
        if (!groupTotal[groupId]) {
          delete updatedState[groupId];
        }
      });
  
      Object.keys(groupTotal).forEach((groupId) => {
        if (!updatedState[groupId]) {      
          updatedState[groupId] = {};
        }
      });
  
      return updatedState;
    });

  };

  return (
    <>      
      {fields && fields.length > 0 && (
        
        <>
          {fields[0].groups.map((group, groupIndex) => {
            const groupColumns = group.columns;
            const groupLabel = group.label;
            const column = 12 / groupColumns;
            const groupidentifier = group.identifier;
            const unit = group.unit;
  
            return (
              <div className="row mt-4" key={groupIndex} ref={(el) => { if (groupidentifier) { sampleFieldRef.current[groupidentifier] = el; } }}>           
                {groupLabel && (
                  <label htmlFor={groupLabel} className="form-label">{groupLabel}</label>
                )}
  
                {group.group_col && group.group_col.map((col, colIndex) => {

                  const colLabel = col.label;
                  const coltext = colLabel ? colLabel.toLowerCase().trim().replace('*', '').replace(/<[^>]+>/g, '').replace(/[^a-z0-9\s-]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-') : '';                  

                  return (
                    <Fragment  key={colIndex}>
                    <div className={ col.id == 3 ? 'col-5' : col.id == 2 ?  'col-3' : `col-${column}`} key={colIndex}>

                      {col.label && (
                        <label htmlFor={col.label} className={`mb-5 form-label left-0 ${coltext}wrapper`} dangerouslySetInnerHTML={{ __html: col.label }} />
                      )}
  
                      {col.fields && col.fields.map((f, fieldIndex) => {
                        // if(f.name.includes('numberoftubes')){
                        //   updateGroupVolume(groupidentifier, f.name, unit,  f.values);

                        // }
                        let isFingerNote = f.name == 'bloodfingerpricknote';
                        let dependentField = f.name.includes('type') ? f.name.replace('type', 'numberoftubes') : (f.name.includes('numberoftubes') ? f.name.replace('numberoftubes', 'size')  : '');
                        if (f.name.includes('size')) {
                          sizes[f.name] = f.label;
                        }

                        return (
                          <div ref={isFingerNote ? fingerNoteRef : null} className={`custom-type-${f.type_text.toLowerCase()}`} key={fieldIndex} style={{ display:  f.name.includes('numberoftubes')? '': !isFingerNote  ? 'block'  :'none' }} >
                            {renderFields(f.type_text, f.label, f.name, f.placeholder, f.note, f.required, f.disabled, f.values, groupidentifier, unit, dependentField)}
                          </div>
                        );
                      })}
                      <div><strong>{col.note}</strong></div>  
                    </div>
                    </Fragment>
                  );
                })}

                <div className="col-12  "><strong>{group.note}</strong></div>
                {groupidentifier && groupCheck.includes(groupidentifier) && (
                    <div className="col-12 mb-2 mt-2">The amount you have requested per volunteer: {temp[groupidentifier]} {unit}</div>
                )}
                
                {error && error[groupidentifier] && (
                  <div className="col-12 mb-2 mt-2 text-danger">{error[groupidentifier]}</div>
                )}
              </div>
            );
          })}
        </>           
      )} 
    </>
  );    
};

export default CustomFields;